/**
 * Installed and offline (owner, 2026-10-16: "I'd like to use this on a flight"): production builds
 * register dist/sw.js (scripts/serviceWorker.ts), which precaches the whole app, so Huebo opens and
 * plays with no network. Not in dev, where it would serve stale modules over Vite's.
 */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
  const register = () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => console.error('[sw] register failed', err))
  }
  if (document.readyState === 'complete') register()
  else window.addEventListener('load', register, { once: true })
}

/**
 * Worlds live in localStorage and IndexedDB, which a browser may clear when the device is short
 * of space; asking for persistent storage keeps them (granted at once to an installed app).
 */
export function requestPersistentStorage(): void {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) return
  void navigator.storage.persisted().then((already) => (already ? true : navigator.storage.persist()))
}
